"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateIngredientListMutation = void 0;
const client_1 = require("@apollo/client");
exports.updateIngredientListMutation = client_1.gql `
  mutation UpdateIngredientList($newList: [String!]!) {
    updateIngredientList(newList: $newList)
  }
`;
//# sourceMappingURL=UpdateIngredientList.js.map